<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system';
	// Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { getTrvComponentByDevice } from 'src/helpers/virtual_helpers/blutrv_helpers';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	//Types
	import type { Device } from 'src/types/Device';

	let className = '';
	export { className as class };

	export let device: Device,
		action: 'target' | 'position',
		disabled: boolean = false;

	let message = '';
	const enableTrv = device && getTrvComponentByDevice(device)?.config?.['trv:0']?.enable;
	if (action === 'target' && !enableTrv) {
		message = $format('trv_alert_warning_temp_control_disabled', {
			default: "This action won't apply as automatic temperature control is disabled.",
		});
	} else if (enableTrv && action === 'position') {
		message = $format('trv_alert_warning_temp_control_enabled', {
			default: "This action won't apply as automatic temperature control is enabled.",
		});
	}
</script>

{#if device && message}
	<div class={className} style={disabled ? 'opacity: 0.4;pointer-events: none' : ''}>
		<Alert
			type="warning"
			heading={capFirstChar(
				$format('alert_warning_generic_attention', {
					default: 'Attention!',
				}),
			)}
			isHeadingBold
			{message}
			cta={{
				title: $format('trv_configure_automatic_temperature_control', {
					default: 'Configure Automatic Temperature Control',
				}),
			}}
			on:cta_click={() => navigateToSetting(device.id, 'settings', 'trv_temp_control')}
		/>
	</div>
{/if}
